export default __webpack_public_path__ + "static/media/blumeattempt-justlikeyou-03.bcf1e98b.jpg";